import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import BuilderAreas from '../../components/BuilderAreas';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import InsideFyhHeader from '../../components/InsideFyhHeader';
import CtaBanner from '../../components/CtaBanner';
import TestimonialBanner from '../../components/TestimonialBanner';
import AreaSection from '../../components/AreaSection';
import FilterBar from '../FilterBar';
import MenuProduct from '../../components/MenuProduct';
import HomesResults from './HomesResults';

const sortOptions = [
  { title: 'Address', field: 'address.streetAddress' },
  { title: 'City', field: 'address.addressLocality' },
];

class CardsListVertical extends React.Component {
  constructor(props) {
    super(props);

    const increment = 24;
    this.state = {
      increment,
      limit: increment,
      sort: sortOptions[0],
    };

    this.showMore = this.showMore.bind(this);
    this.setSort = this.setSort.bind(this);
  }

  setSort(sort) {
    let dir = 'asc';
    if (sort.title === this.state.sort.title) {
      dir = this.state.sort.dir === 'desc' ? 'asc' : 'desc';
    }
    this.setState({
      sort: { ...sort, dir },
    });
  }

  showMore() {
    this.setState({
      limit: this.state.limit + this.state.increment,
    });
  }

  render() {
    const { area, homes, metro, submetro, page } = this.props;
    const { limit, sort } = this.state;

    const areaName = get(area, 'name') ? get(area, 'name') : 'Eastern NC';

    const h2 = submetro.name ? metro.name : undefined;
    return (
      <div>
        <InsideFyhHeader
          h1={`${areaName}`}
          h1Span="Quick Move-In Homes"
          h2={h2}
          background={get(page, 'page_image.contentUrl')}
        />
        <PageHelmet custom title={`Quick Move-In Homes in ${get(area, 'name') || 'Eastern NC'} | 70 West Builders`} />
        <Header />
        <MenuProduct />
        <FilterBar
          itemCount={homes.length}
          showingCount={limit > homes.length ? homes.length : limit}
          type="homes"
          sortOptions={sortOptions}
          setSortBy={this.setSort}
          filterOptions={[
            {
              type: 'MultiSelect',
              filter: 'Area',
              title: 'Area',
              placeholder: 'All Cities',
            },
            {
              type: 'MultiSelect',
              filter: 'City',
              title: 'City',
              placeholder: 'All Cities',
            },
            {
              type: 'MultiSelect',
              filter: 'Beds',
              title: 'Beds',
              placeholder: 'All',
            },
            {
              type: 'MultiSelect',
              filter: 'Baths',
              title: 'Baths',
              placeholder: 'All',
            },
            {
              type: 'MultiSelect',
              filter: 'Community',
              title: 'Community',
              placeholder: 'All',
            },
            {
              type: 'MultiSelect',
              filter: 'Price',
              title: 'Price Range',
              placeholder: 'All',
            },
            // {
            //   type: 'MultiSelect',
            //   filter: 'MoveInDate',
            //   title: 'Move-In Date',
            //   placeholder: 'All Cities',
            // },
          ]}
        />
        <div className="clearfix" />
        <HomesResults sort={sort} limit={limit} />
        <div id="area-info" />
        <BuilderAreas />
        <CtaBanner />
        <AreaSection />
        <TestimonialBanner />
        <Footer />
      </div>
    );
  }
}

CardsListVertical.propTypes = {
  homes: PropTypes.arrayOf(PropTypes.object),
  metro: PropTypes.object,
  submetro: PropTypes.object,
  area: PropTypes.object,
  page: PropTypes.object,
};

CardsListVertical.defaultProps = {
  homes: [],
  metro: {},
  submetro: {},
  area: undefined,
  page: undefined,
};

export default withData(
  {
    homes: true,
    metro: true,
    submetro: true,
    area: true,
    page: 'available_homes',
  },
  {
    required: {
      homes: true,
    },
  },
)(CardsListVertical);



// WEBPACK FOOTER //
// ./src/pages/HomesOriginal/CardsList.js